import React from "react";
import Slider from "react-slick";
import { upperCase } from "lodash";
import { carouselConfigMobile, carouselConfigWeb } from "@stadium/constants";

import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";
import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";

import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";

// import "./styles/InstaSlider.module.scss";

const responseSliderSettings = [
  {
    breakpoint: 992,
    settings: {
      ...carouselConfigMobile,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      touchMove: true,
      swipeToSlide: true,
      autoplay: true,
      dots: true,
      arrows: true,
    },
  },
  {
    breakpoint: 767,
    settings: {
      ...carouselConfigMobile,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      touchMove: true,
      swipeToSlide: true,
      autoplay: true,
      dots: true,
      arrows: true,
    },
  },
];

const carouselConfig = {
  ...carouselConfigWeb,
  autoplay: false,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  className: "center",
  centerMode: true,
  centerPadding: "60px",
  dots: true,
  arrows: true,
  responsive: responseSliderSettings,
  touchMove: false,
  autoplaySpeed: 5000,
};

const ImageSlider = ({ doc }) => {
  const { internal_link_id, heading, link_text, link, description, bg_color, button_effect } =
    doc?.primary || {};
  const sectionStyle = { backgroundColor: bg_color };

  return (
    <div className="py-5 py-2xl-5 insta-slider-section prismic-slice" style={sectionStyle}>
      <div className="container container-width slider-section-container">
        {internal_link_id && (
          <span id={internal_link_id} className="scroll-point position-relative d-block" />
        )}
        <div className="slider-section-container-in container-width">
          <div className="slider-section-header-block">
            {checkContentPresence(heading) && (
              <div className="text-center sns-h2 insta-section-title same-size-title">
                {textResolver(heading)}
              </div>
            )}
            {checkContentPresence(description) && (
              <div className="text-center sns-h2 insta-description">
                {textResolver(description)}
              </div>
            )}
          </div>
          {checkContentPresence(link_text) && (
            <div className="d-none d-lg-block insta-slider-link-row">
              <PrismicLinkTag
                url={link?.url}
                urlText={upperCase(link_text)}
                target="_blank"
                className={`${button_effect} px-5 font-weight-bold text-center no-underline text-uppercase text-break ls-3`}
              />
            </div>
          )}
        </div>
        <div className="py-5 py-2xl-5 insta-slider-section container-width" style={sectionStyle}>
          <Slider {...carouselConfig}>
            {doc.items.map(({ image, background_color }, index) => (
              <div className="insta-slider-block" key={`image-${index}`}>
                <div
                  className={`insta-slider-image-holder ${background_color ? "p-4" : ""} `}
                  style={{ backgroundColor: background_color }}
                >
                  <PrismicImgix
                    alt={image?.alt}
                    src={image?.url}
                    className="img-responsive img-responsive-height insta-slider-img"
                    desktop="350px"
                    mobile="360px"
                    tablet="275px"
                    largeDisplay="650px"
                  />
                </div>
              </div>
            ))}
          </Slider>
        </div>
        {checkContentPresence(link_text) && (
          <div className="d-block d-lg-none text-center mt-5 insta-slider-link-row">
            <PrismicLinkTag
              url={link?.url}
              urlText={upperCase(link_text)}
              target="_blank"
              className={`${button_effect} px-4 font-weight-bold text-center no-underline text-uppercase text-break ls-3`}
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default ImageSlider;
